export default "__VITE_ASSET__CFHvz2SW__"